<template>
  <v-dialog
    v-model="show"
    max-width="600"
    :persistent="topUpLoading"
    :fullscreen="this.$vuetify.breakpoint.xs"
    id="balance-top-up-dialog"
  >
    <v-card>
      <v-row class="pa-5 ma-0">
        <v-card-title class="justify-center display-3 font-weight-bold">{{
          this.$t("title.topup_balance")
        }}</v-card-title>
        <v-spacer></v-spacer>
        <v-btn
          class="text-right"
          icon
          @click="show = false"
          :disabled="topUpLoading"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-row>

      <v-card-text>
        <v-row>
          <v-col class="text-center">
            <div class="display-1">
              {{ this.$t("message.current_balance") }}
            </div>
            <div class="primary--text display-3 font-weight-medium">
              {{ $store.state.user.balance / 100 || 0 | currency }}
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-text>
        <v-row>
          <v-col>
            <v-form ref="topupform" v-model="valid">
              <v-tabs
                v-model="tab"
                grow
                color="primary"
                center-active
                show-arrows
                icons-and-text
                class="pb-5"
              >
                <v-tab v-for="item in tabItems" :key="item.key">
                  {{ $t(item.translation) }}
                  <v-icon>{{ item.icon }}</v-icon>
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <v-item-group mandatory class="mb-5" v-model="selected">
                    <v-row>
                      <v-col
                        v-for="n in $store.state.config.prepaid_bonuses"
                        :key="n.uuid"
                        cols="auto"
                      >
                        <v-item v-slot:default="{ active, toggle }">
                          <v-btn
                            :text="!active"
                            @click="toggle"
                            color="primary"
                            :disabled="topUpLoading"
                          >
                            <div class="display-1 font-weight-medium">
                              {{ (n.amount / 100) | currency }}
                            </div>
                          </v-btn>
                        </v-item>
                      </v-col>
                    </v-row>
                  </v-item-group>
                </v-tab-item>
                <v-tab-item>
                  <v-text-field
                    :disabled="topUpLoading"
                    style="margin-top:3px"
                    validate-on-blur
                    :label="this.$t('label.amount')"
                    prefix="€"
                    v-money="money"
                    v-model="amount_euros"
                    :rules="rules.amount"
                    outlined
                  ></v-text-field>
                </v-tab-item>
              </v-tabs-items>
              <v-scale-transition>
                <div>
                  <v-divider class="my-4"></v-divider>
                  <div>
                    {{
                      this.$t("message.free_prepaid_bonus", {
                        bonus_amount: this.calculateBonusAmount()
                      })
                    }}
                  </div>
                  <v-divider class="my-4"></v-divider>
                </div>
              </v-scale-transition>
              <v-row>
                <v-col cols="auto">
                  <v-checkbox
                    v-model="acceptConditions"
                    :disabled="topUpLoading"
                    color="primary"
                    :label="this.$t('label.accept_terms_and_conditions')"
                    class="mt-0"
                  >
                    <template slot="append">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon @click="gotoConditions" v-on="on"
                            >mdi-script-text-outline
                          </v-icon>
                        </template>
                        <span>{{
                          this.$t("label.open_terms_and_conditions")
                        }}</span>
                      </v-tooltip>
                    </template>
                  </v-checkbox>
                </v-col>
              </v-row>
            </v-form>
          </v-col>
        </v-row>
      </v-card-text>

      <div class="pl-5 pb-5">
        <v-btn
          color="primary"
          @click="pay"
          class="no-text-transform display-1"
          :disabled="
            selected === undefined ||
              !acceptConditions ||
              (tab === 1 ? !valid : false)
          "
          :loading="topUpLoading"
          >{{ this.$t("button.pay") }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "balanceTopUpDialog",
  props: ["value"],

  data() {
    return {
      dynamic_topup_amount: 0,
      selected: 0,
      acceptConditions: false,
      topUpLoading: false,
      tab: 0,
      money: {
        precision: 2,
        decimal: ",",
        thousands: ".",
        masked: false
      },
      busyCreating: false,
      valid: false,
      amount_euros: "0",
      rules: {
        amount: [
          v =>
            this.validateAmount(v) ||
            this.$t("rules.between_min_and_max_dynamic_topup", {
              min_amount: this.$options.filters.currency(
                this.$store.getters["config/getMinimumDynamicAmount"] / 100
              ),
              max_amount: this.$options.filters.currency(
                this.$store.getters["config/getMaximumDynamicAmount"] / 100
              )
            })
        ]
      }
    };
  },
  computed: {
    tabItems() {
      let tabItems = [
        {
          key: "default_topup_amounts",
          translation: "tab.default_topup_amounts"
        }
      ];
      if (this.$store.getters["config/hasDynamicTopupAmount"]) {
        tabItems.push({
          key: "dynamic_topup_amounts",
          translation: "tab.dynamic_topup_amounts"
        });
      }
      return tabItems;
    },
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    topUpAmountAndBonus() {
      if (this.tab === 0) {
        return this.$store.state.config.prepaid_bonuses[this.selected];
      } else {
        return {
          amount: this.dynamic_topup_amount,
          bonus: this.getDynamicBonus(this.dynamic_topup_amount),
          dynamic: true
        };
      }
    }
  },
  watch: {
    amount_euros: function(val) {
      this.dynamic_topup_amount =
        parseFloat(val.replaceAll(".", "").replace(",", ".")) * 100;
    }
  },
  methods: {
    getDynamicBonus(input_amount) {
      let prepaid_amounts = JSON.parse(
        JSON.stringify(this.$store.state.config.prepaid_bonuses)
      );

      prepaid_amounts.sort((a, b) => a.amount - b.amount);

      let bonus_amount = 0;
      for (let i = 0; i < prepaid_amounts.length; i++) {
        if (input_amount >= prepaid_amounts[i].amount) {
          bonus_amount = prepaid_amounts[i].bonus;
        }
      }

      return bonus_amount;
    },
    calculateBonusAmount() {
      let amount = 0;
      if (this.tab === 0) {
        amount = this.getPrepaidAmountBonus(this.selected);
      } else if (this.tab === 1) {
        amount = this.getDynamicBonus(this.dynamic_topup_amount);
      }
      return this.$options.filters.currency(amount / 100);
    },
    pay() {
      if (this.tab === 1 && !this.$refs.topupform.validate()) {
        return;
      }
      this.topUpLoading = true;
      this.$store.dispatch("topup/topup", this.topUpAmountAndBonus);
    },
    gotoConditions() {
      this.$router.push("/auth/privacystatement");
    },
    getPrepaidAmountBonus(item) {
      return this.$store.state.config.prepaid_bonuses[item]["bonus"];
    },
    validateAmount(val) {
      val = parseFloat(val.replaceAll(".", "").replace(",", ".")) * 100;

      if (isNaN(val) || val === 0) {
        return false;
      }

      const minAmount = this.$store.getters["config/getMinimumDynamicAmount"];
      const maxAmount = this.$store.getters["config/getMaximumDynamicAmount"];

      if (!minAmount) {
        return false;
      }

      return val >= minAmount && (maxAmount === null || val <= maxAmount);
    }
  }
};
</script>

<style scoped></style>
